import theme from './common/theme/index';

export default (_theme, _params, classes) => ({
    closeIcon: {
        color: theme.palette.common.white,
    },
    success: {
        backgroundColor: theme.palette.primary.main,
        [`& .${classes.closeIcon}`]: {
            color: theme.palette.primary.contrastText,
        },
    },
    info: {
        backgroundColor: theme.palette.secondary.main,
        [`& .${classes.closeIcon}`]: {
            color: theme.palette.secondary.contrastText,
        },
    },
    warning: {
        backgroundColor: theme.palette.tertiary.main,
        [`& .${classes.closeIcon}`]: {
            color: theme.palette.tertiary.contrastText,
        },
    },
    error: {
        backgroundColor: theme.palette.error.main,
        [`& .${classes.closeIcon}`]: {
            color: theme.palette.error.contrastText,
        },
    },
});
